<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <div>
            <!-- TODO: Migliorare la pagina -->
            <button class="btn"
              v-for="entry in languages"
              :key="entry.title"
              @click="changeLocale(entry.language)"
            >{{entry.title}}</button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PageTitle from "../../components/PageTitle";
import i18n from '@/config/i18n';
import { langPage } from '@/lang/index'
export default {
  name: "userPage",
  components: {
    PageTitle
  },
  data() {
    return {
      languages: langPage
    };
  },
  methods: {
    changeLocale(locale) {
      i18n.locale = locale;
    }
  }
};
</script>
